import { RelatedIndex } from './RelatedPages';
export default function Page() { return <RelatedIndex locale="ja" />; }
